"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloudinaryParamsToString = exports.serializeParams = exports.serializeToUseEffectString = void 0;
var keyValuePairToString = function (key, value) {
    return key + "=" + value;
};
// Serializes the given object to a string that useEffect will
// check for changes; by sorting the keys, we ensure that two
// objects are the same if they have the same values, even if their
// keys are in a different order.
//
// (This is probably a pretty rare edge case, but I guess it can't hurt?)
function serializeToUseEffectString(obj) {
    // Make sure that all of an object's keys are sorted so that we can ensure the exact
    // same serialzation.
    function sortDeep(obj) {
        if (typeof (obj) === "object") {
            if (Array.isArray(obj)) {
                return obj.map(sortDeep);
            }
            else if (obj === null) {
                return null;
            }
            else {
                var newObj_1 = {};
                var keys = __spreadArray([], Object.keys(obj)).sort();
                keys.forEach(function (key) { return newObj_1[key] = sortDeep(obj[key]); });
                return newObj_1;
            }
        }
        else {
            return obj;
        }
    }
    return JSON.stringify(sortDeep(obj));
}
exports.serializeToUseEffectString = serializeToUseEffectString;
var serializeParams = function (params) {
    var paramList = [];
    for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (typeof (value) === "object") {
            if (Array.isArray(value)) {
                for (var _c = 0, value_1 = value; _c < value_1.length; _c++) {
                    var item = value_1[_c];
                    if (typeof (item) === 'object') {
                        for (var innerKey in item) {
                            paramList.push(keyValuePairToString(key + "[" + encodeURIComponent(innerKey) + "]", encodeURIComponent(item[innerKey])));
                        }
                    }
                    else {
                        // Repeat the param for each element
                        paramList.push(keyValuePairToString(key, encodeURIComponent(item)));
                    }
                }
            }
            else if (value === null || value === undefined) {
                continue;
            }
            else {
                for (var _d = 0, _e = Object.entries(value); _d < _e.length; _d++) {
                    var _f = _e[_d], valKey = _f[0], valVal = _f[1];
                    paramList.push(keyValuePairToString(key + "[" + valKey + "]", encodeURIComponent(valVal)));
                }
            }
        }
        else {
            if (value !== undefined) {
                //@ts-ignore
                paramList.push(keyValuePairToString(key, encodeURIComponent(value)));
            }
        }
    }
    var result = paramList.join('&');
    return result;
};
exports.serializeParams = serializeParams;
var cloudinaryParamsToString = function (params) {
    if (!params) {
        return undefined;
    }
    if (typeof params === "string") {
        return params;
    }
    return Object.entries(params)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return key + "=" + value.toString();
    })
        .join(',');
};
exports.cloudinaryParamsToString = cloudinaryParamsToString;
//# sourceMappingURL=helpers.js.map